import usePaging from "../../../hooks/usePaging";
import { useGetAssessmentsFinishedQuery } from "../assessmentsSlice";
import { useLocation } from "react-router-dom";
import useHasAccess from "../../../hooks/useHasAccess";
import useRefresher from "../../../hooks/useRefresher";

const useAssessmentsFinished = () => {
  const { activePage } = usePaging({});
  const location = useLocation();
  const hasAccess = useHasAccess({
    apiCall: "assessments.GET",
  });

  const assessments = useGetAssessmentsFinishedQuery({
    page: location?.pathname?.includes("assessments_finished") ? activePage : 1,
  });
  useRefresher(assessments);

  return {
    ...assessments,
    data: assessments?.data?.response,
    pagination: assessments?.data?.pagination,
    hasAccess,
  };
};

export default useAssessmentsFinished;
